import { Control } from "react-hook-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";

import { InvoiceFormValues } from "./types";

interface InvoiceNotesFieldProps {
  control: Control<InvoiceFormValues>;
  disabled?: boolean;
}

const InvoiceNotesField = ({ control, disabled }: InvoiceNotesFieldProps) => {
  return (
    <FormField
      control={control}
      name="notes"
      render={({ field }) => (
        <FormItem className="space-y-2">
          <FormLabel>Notes / Memo</FormLabel>
          <FormControl>
            <Textarea
              placeholder="Add any notes for the client (e.g. payment instructions, thank you message)"
              className="min-h-[80px] resize-none text-sm"
              {...field}
              disabled={disabled}
            />
          </FormControl>
          <p className="text-xs text-muted-foreground">
            Visible to the client on the invoice
          </p>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default InvoiceNotesField;
